// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3xArST1HI0Voc- {\n  background-color: transparent;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerButton": "_3xArST1HI0Voc-"
};
export default ___CSS_LOADER_EXPORT___;
